import script from "./UDecimal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UDecimal.vue?vue&type=script&setup=true&lang=ts"

import "./UDecimal.vue?vue&type=style&index=0&id=5ea0ac80&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ea0ac80"]])

export default __exports__